'use client'

import { AuthShell } from './auth-shell'

export function AuthLoadingSkeleton({ boxHeights }: { boxHeights: readonly string[] }) {
  return (
    <AuthShell>
      <div
        style={{ opacity: 0.35, display: 'flex', flexDirection: 'column', gap: '24px' }}
        aria-hidden="true"
      >
        {boxHeights.map((height, index) => (
          <div
            key={index}
            style={{ height, background: 'var(--hairline-faint)', borderRadius: '12px' }}
          />
        ))}
      </div>
    </AuthShell>
  )
}
